import { useCallback, useEffect, useState } from 'react';
import ApiDatabase from 'server';

// The route's own key: leaving the tab or closing the panel cancels this read
// and nothing else.
export const HISTORY_ABORT_KEY = 'admin/invoices/:number/events';

/**
 * The history of an invoice (JBWEB-1278), read when its tab opens and again
 * when `refreshKey` changes (the end of an import run). `failure` is
 * "notFound" (404: Jobbiz has no such invoice) or "failed".
 */
const useInvoiceHistory = (number, refreshKey = 0) => {
  const [state, setState] = useState({
    events: null,
    isLoading: true,
    failure: null,
  });
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!number) return undefined;
    let active = true;
    setState((previous) => ({ ...previous, isLoading: true, failure: null }));
    ApiDatabase.getInvoiceEvents(
      { number },
      (data) => {
        if (!active) return;
        setState({
          events: Array.isArray(data?.items) ? data.items : [],
          isLoading: false,
          failure: null,
        });
      },
      (error) => {
        if (!active || error?.name === 'CanceledError') return;
        // Never the error object in the console: axios keeps the request, token included.
        setState({
          events: null,
          isLoading: false,
          failure: error?.response?.status === 404 ? 'notFound' : 'failed',
        });
      },
      { abortKey: HISTORY_ABORT_KEY },
    );
    return () => {
      active = false;
    };
  }, [number, refreshKey, reloadKey]);

  useEffect(() => () => ApiDatabase.abortRequest(HISTORY_ABORT_KEY), []);

  const reload = useCallback(() => setReloadKey((key) => key + 1), []);
  return { ...state, reload };
};

export default useInvoiceHistory;
